import React from 'react'
import { generateCss, generateEvent, generateStyle } from '../../functions/sortableFunctions';

const CircularText = ({ block, ...props }: any) => {
    return (
        <React.Fragment>
            {
                React.createElement(
                    block?.type,
                    {
                        key: block?.id,
                        id: block?.id,
                        style: generateStyle({
                            props: {
                                ...props,
                                block
                            }
                        }),
                        className: `relative !h-[${block?.data?.circularTextRadius * 2}px] !w-[${block?.data?.circularTextRadius * 2}px] ${generateCss({
                            props: {
                                ...props,
                                block: block
                            },
                        })}`,
                        disabled: block?.data?.type == 'submit' ? props?.formik?.isSubmitting : null,
                        onClick: block.events?.onClick ? async (e: any) => {
                            await generateEvent({
                                props: {
                                    ...props,
                                    block: block
                                },
                                e: e,
                                event: "onClick"
                            });
                        } : null,
                        onDoubleClick: block.events?.onDoubleClick ? async (e: any) => {
                            await generateEvent({
                                props: {
                                    ...props,
                                    block: block
                                },
                                e: e,
                                event: "onDoubleClick"
                            });
                        } : null,
                        onContextMenu: block.events?.onContextMenu ? async (e: any) => {
                            await generateEvent({
                                props: {
                                    ...props,
                                    block: block
                                },
                                e: e,
                                event: "onContextMenu"
                            });
                        } : null,
                        onMouseOver: block.events?.onMouseOver ? async (e: any) => {
                            await generateEvent({
                                props: {
                                    ...props,
                                    block: block
                                },
                                e: e,
                                event: "onMouseOver"
                            });
                        } : null,
                        onMouseLeave: block.events?.onMouseLeave ? async (e: any) => {
                            await generateEvent({
                                props: {
                                    ...props,
                                    block: block
                                },
                                e: e,
                                event: "onMouseLeave"
                            });
                        } : null
                    },

                    block?.content?.split('')?.map((char: any, i: any) => {
                        return (
                            <React.Fragment>
                                <span className={`rotate-[${i * (360 / block?.content?.length)}deg] absolute left-1/2 `} style={{ transformOrigin: `0 ${block?.data?.circularTextRadius}px` }}>{char}</span>
                            </React.Fragment>
                        )
                    })

                )
            }
        </React.Fragment>
    )
}

export default CircularText;